var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconWiki = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(6.442 8.156)" },
                React.createElement("path", { d: "M19.4,11.3c0,4-3.3,7.3-7.3,7.3s-7.3-3.3-7.3-7.3S8.1,4,12.1,4c0,0,0,0,0,0\n\t\tC16.2,4,19.4,7.3,19.4,11.3z" }),
                React.createElement("path", { d: "M21.2,20.4l-4-4" })),
            React.createElement("g", { transform: "translate(-684.809 -425.379)" },
                React.createElement("line", { strokeWidth: "1", x1: "689.8", y1: "427.7", x2: "695.2", y2: "435.8" }),
                React.createElement("line", { strokeWidth: "1", x1: "695.2", y1: "435.8", x2: "687.1", y2: "448.3" }),
                React.createElement("line", { strokeWidth: "1", x1: "687.1", y1: "448.3", x2: "697.8", y2: "448.3" }),
                React.createElement("line", { strokeWidth: "1", x1: "697.8", y1: "448.3", x2: "700.5", y2: "443.8" }),
                React.createElement("line", { strokeWidth: "1", x1: "700.5", y1: "443.8", x2: "702.3", y2: "446.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "702.3", y1: "446.5", x2: "709.4", y2: "446.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "709.4", y1: "446.5", x2: "703.2", y2: "438.4" }),
                React.createElement("line", { strokeWidth: "1", x1: "703.2", y1: "438.4", x2: "711.2", y2: "426.8" }),
                React.createElement("line", { strokeWidth: "1", x1: "711.2", y1: "426.8", x2: "700.5", y2: "426.8" }),
                React.createElement("line", { strokeWidth: "1", x1: "700.5", y1: "426.8", x2: "698.7", y2: "430.4" }),
                React.createElement("line", { strokeWidth: "1", x1: "698.7", y1: "430.4", x2: "696.9", y2: "427.7" }),
                React.createElement("line", { strokeWidth: "1", x1: "696.9", y1: "427.7", x2: "689.8", y2: "427.7" })))));
});
export default IconWiki;
//# sourceMappingURL=IconWiki.js.map